import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/app/Main.vue'
import SecureLevel from '../views/app/SecureLevel.vue'
import Board from '@/views/app/Board.vue'
import PrivacyPolicy from '@/views/app/PrivacyPolicy.vue'
import Infou from '@/views/app/Infou.vue'
import User from '@/views/app/User.vue'
import Agree from '@/views/app/main/Agree.vue'
import InputInfo from '@/views/app/main/InputInfo.vue'
import CheckInfo from '@/views/app/main/CheckInfo.vue'
import SelectIdc from '@/views/app/main/SelectIdc.vue'
import SimpleLayout from '@/layout/SimpleLayout.vue'
import AppLayout from '@/layout/AppLayout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    component: SimpleLayout,
    redirect: 'home',
    children:[
      {
        name: 'nscauthorize',
        path: 'nscauthorize',
        component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
      },
      {
        name: 'home',
        path: 'home',
        component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
      },
      {
        name: 'request',
        path: 'request',
        component: () => import(/* webpackChunkName: "about" */ '../views/Request.vue')
      },
      {
        name: 'employeeRequest',
        path: 'employeeRequest',
        component: () => import(/* webpackChunkName: "about" */ '../views/EmployeeRequest.vue')
      },
      {
        name: 'manualEnter',
        path: 'manualEnter',
        component: () => import(/* webpackChunkName: "about" */ '../views/ManualEnter.vue')
      },
      {
        name: 'check',
        path: 'check',
        component: () => import(/* webpackChunkName: "about" */ '../views/Check.vue')
      },
      {
        name: 'qrScan',
        path: 'qrScan',
        component: () => import(/* webpackChunkName: "about" */ '../views/QRScan.vue')
      },
      {
        name: 'healthCheck',
        path: 'monitor/l7check',
        component: () => import(/* webpackChunkName: "about" */ '../views/HealthCheck.vue')
      },
      {
        name: 'app',
        path: 'app',
        component: AppLayout,
        children: [
          {
            name: 'main',
            path: 'main',
            component: Main,
            beforeEnter: (to, from, next) => {
              //TODO : 토큰 정보와, 현재 로그인 한 emp 정보가 다를 경우 logout 처리
              window.store.dispatch("auth/validation")
                .then((result) => {
                  if(result) {
                    //임직원이 다른 임직원 이름으로 출입신청을 못하게 방지
                    if(window.store.state.login.empEmail != null && window.store.state.login.empEmail != window.store.state.auth.employee.empEmail){
                      next("/request")
                    }
                    next();
                  }
                  else next("/request")
                });

            },
            children:[
              {
                path: '',
                component: SelectIdc
              },
              {
              name: 'selectIdc',
              path: 'selectIdc',
              component: SelectIdc,
              },
              {
                name: 'agree',
                path: 'agree',
                component: Agree,
                props: true
              },
              {
                name: 'inputInfo',
                path: 'inputInfo',
                component: InputInfo,
                props: true
              },
              {
                name: 'checkInfo',
                path: 'checkInfo',
                component: CheckInfo,
                props: true
              }
            ],
          },
          {
            name: 'secureLevel',
            path: '/app/secureLevel',
            component: SecureLevel
          },
          {
            name: 'notice',
            path: '/app/notice',
            component: Board
          },
          {
            name: 'noticeDetail',
            path: '/app/notice/:id',
            component: Board
          },
          {
            name: 'privacyPolicy',
            path: '/app/privacyPolicy',
            component: PrivacyPolicy
          },
          {
            name: 'privacyPolicyDetail',
            path: '/app/privacyPolicy/:id',
            component: PrivacyPolicy
          },
          {
            name: 'infou',
            path: '/app/infou',
            component: Infou
          },
          {
            name: 'infouDetail',
            path: '/app/infou/:id',
            component: Infou
          },
          {
            name: 'requestLookup',
            path: '/app/requestLookup',
            component: () => import(/* webpackChunkName: "inout" */ '../views/app/RequestLookup.vue')
          },
          {
            name: 'user',
            path: '/app/user',
            component: User
          },
          {
            name: 'inOut.bookList',
            path: '/app/inOut/BookList',
            component: () => import(/* webpackChunkName: "inout" */ '../views/app/InOut.vue')
          },
          {
            name: 'inOut.manager',
            path: '/app/inOut/Manager',
            component: () => import(/* webpackChunkName: "inout" */ '../views/app/InOut.vue')
          },

          {
            path: 'complience',
            name: 'complience',
            component: () => import(/* webpackChunkName: "about" */ '../views/app/complience/Complience.vue')
          },
          {
            path: 'siteManager',
            name: 'siteManager',
            component: () => import(/* webpackChunkName: "about" */ '../views/app/siteManager/SiteManager.vue')
          },
          {
            path: 'location',
            name: 'location',
            component: () => import(/* webpackChunkName: "about" */ '../views/app/Location.vue')
          },
          {
            path: 'selectlocation',
            name: 'selectlocation',
            component: () => import(/* webpackChunkName: "about" */ '../views/app/SelectLocation.vue'),
            props: true
          },
          {
            path: 'calendar',
            name: 'calendar',
            component: () => import(/* webpackChunkName: "about" */ '../views/app/Calendar.vue')
          },
          {
            path: 'statistics',
            name: 'statistics',
            component: () => import(/* webpackChunkName: "about" */ '../views/app/statistics/Statistics.vue')
          },
          {
            path: '/app/booking/calendar',
            name: 'bookingCalendar',
            component: () => import('../views/app/booking/Calendar')
          },
          {
            path: '/app/manager/booking/calendar',
            name: 'bookingCalendarManager',
            component: () => import('../views/app/booking/Calendar')
          }
        ]
      }
    ],
  },
  // {
  //   path: '/lib/*'
  // },
  {
    path: '*',
    redirect: '/'
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {

  //사원 정보 체크
  async function checkLevel(){
    var a = to;
    var b = from;
    var login = await window.store.dispatch("login/LOGIN");

    //권한 처리 영역
    // if(login) {

      if(window.store.state.location.idcList == null) {
        window.store.dispatch('location/setIdcList', window.store.state.login.empNumber).then(() => {
          //LNB 에 현재 선택 된 IDC 가 없을 경우 login 주 IDC 로 설정(로그인 된 사용자만 주IDC 정보를 가지고 있음
          if(window.store.getters['location/currentIdc'] == null && window.store.state.login.empNumber != null){
            //로그인된 사용자의 주IDC 코드를 받아와 IDC 정보를 설정함
            if(window.store.state.location.idcList) {
              let currentIdc = window.store.state.location.idcList.filter((data) => {
                return data.locationCode == window.store.getters['login/getDefaultIdcCode'];
              })[0];

              window.store.dispatch('location/setCurrentIdc', currentIdc);
            }
            // next();
          }
          // next();
          checkAuth(to, from, next);
        })
      }
      else{
        // next();
        checkAuth(to, from, next);
      }


    // }



  }

  function checkAuth(to, from, next){
    if(to.path == '' || to.path == '/' || to.path == '/home' || to.path == '/app/notice' || to.path == '/app/requestLookup' || to.path=='/monitor/l7check' || (to.name=='noticeDetail' && to.query.mode=='view')) {
      next();
      return ;
    }

    //var userLv = 4;
    var userLv = window.store.state.login.userLevel;
    if(userLv == null) userLv = 1;
    var lv0 = ['bookingCalendarManager','bookingCalendar'];
    var lv1 = ['home','notice', 'request', 'requestLookup','check','qrScan','manualEnter','employeeRequest', 'selectIdc', 'agree', 'inputInfo', 'checkInfo', 'selectlocation','infou', 'bookingCalendar'];
    var lv2 = lv1.concat(['inOut.manager', 'inOut.bookList', 'calendar', 'statistics']);
    var lv3 = lv2.concat(['user','complience','privacyPolicy']);
    var lv4 = [];
    var level = {lv0: lv0, lv1: lv1, lv2: lv2, lv3: lv3}


    if(level && level['lv' + userLv]){
      if(userLv == 2){
        level.lv2.push('bookingCalendarManager');
      }

      if(userLv >= 4) {

      }else{
        if(level['lv' + userLv].filter((x)=>x == to.name).length > 0){

        }else{
          alert("접근권한이 없습니다.");
          next(from.path);
          return;
        }
      }
    }
    next();
  }

  checkLevel();

  //var login = await window.store.dispatch("login/LOGIN");

  /*
  window.store.dispatch("login/LOGIN")
    .then(() => {
      //IDC store에 IDC 정보가 없으면 세팅 : emp 권한 있는 IDC 정보만 설정
      var permit = ['notice', 'requestLookup'];
      debugger;
      if(window.store.state.location.idcList == null) {

        window.store.dispatch('location/setIdcList', window.store.state.login.empNumber).then(() => {
          //LNB 에 현재 선택 된 IDC 가 없을 경우 login 주 IDC 로 설정(로그인 된 사용자만 주IDC 정보를 가지고 있음
          if(window.store.getters['location/currentIdc'] == null && window.store.state.login.empNumber != null){
            //로그인된 사용자의 주IDC 코드를 받아와 IDC 정보를 설정함
            if(window.store.state.location.idcList) {
              let currentIdc = window.store.state.location.idcList.filter((data) => {
                return data.locationCode == window.store.getters['login/getDefaultIdcCode'];
              })[0];

              window.store.dispatch('location/setCurrentIdc', currentIdc);
            }
            next();
          }
          next();
        })
      }else{
        var permit = ['notice', 'requestLookup'];
        debugger;
        next();
      }

  })
  */

});



export default router
